<template>
  <div class="video-talk">
    <h1>通话数据统计</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 80px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 80px"
        v-model="curCallType.selectValue"
        placeholder=""
      >
        <el-option label="all" value="-1"></el-option>
        <el-option label="视频" value="0"></el-option>
        <el-option label="音频" value="1"></el-option>
      </el-select>
      <el-select
        style="width: 80px"
        v-model="curFromType.selectValue"
        placeholder=""
      >
        <el-option label="all" value="-1"></el-option>
        <el-option label="用户主动拨打" value="1"></el-option>
        <el-option label="主播匹配拨打" value="2"></el-option>
        <el-option label="主播主动拨打" value="3"></el-option>
        <el-option label="用户匹配主播" value="4"></el-option>
        <el-option label="用户匹配用户" value="5"></el-option>
      </el-select>
      <DatePicker @datePickedChange="datePickedChange"></DatePicker>
      <el-button type="primary" @click="doInquery">查询</el-button>
    </div>
    <div class="display-type">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="表格" name="table" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="柱状图" name="bar" class="bar-container">
          <div v-loading="loading">
            <CustomBar :options="barOptions1" class="bar"></CustomBar>
            <CustomBar :options="barOptions2" class="bar"></CustomBar>
            <CustomBar :options="barOptions3" class="bar"></CustomBar>
            <CustomBar :options="barOptions4" class="bar"></CustomBar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="折线图" name="line">
          <div v-loading="loading">
            <CustomLine :options="lineOptions"></CustomLine>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane label="饼状图" name="pie">饼图</el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomBar from '@/components/CustomBar'
import CustomLine from '@/components/CustomLine'
import DatePicker from '@/components/DatePicker'

export default {
  components: {
    CustomTable,
    CustomBar,
    CustomLine,
    DatePicker
  },
  data() {
    return {
      curChannel: {
        selectValue: 'all',
        content: ''
      },
      curCallType: {
        selectValue: '-1',
        content: ''
      },
      curFromType: {
        selectValue: '-1',
        content: ''
      },
      channels: this.$store.state.channels,
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'descending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '100px'
          },
          {
            name: 'callingUserCount',
            label: '成功发起通话人数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'callingCount',
            label: '成功发起通话次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'newCallingUserCount',
            label: '新增用户成功人数',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'newCallingCount',
            label: '新增用户成功次数',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'totalUserCount',
            label: '请求总人数',
            sortable: true,
            fix: true,
            width: ''
          },
          {
            name: 'totalCount',
            label: '请求总次数',
            sortable: true,
            fix: true,
            width: ''
          },
          {
            name: 'totalTime',
            label: '通话总时长',
            sortable: true,
            fix: true,
            width: '140px'
          }
        ]
      },
      barOptions1: {
        title: '通话人数',
        legend: ['通话成功人数', '新增用户通话成功人数'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '人数',
          type: 'value'
        },
        series: [
          {
            name: '通话成功人数',
            type: 'bar',
            data: []
          },
          {
            name: '新增用户通话成功人数',
            type: 'bar',
            data: []
          }
        ]
      },
      barOptions2: {
        title: '通话次数',
        legend: ['通话成功次数', '新增用户通话成功次数'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '次数',
          value: 'value'
        },
        series: [
          {
            name: '通话成功次数',
            type: 'bar',
            data: []
          },
          {
            name: '新增用户通话成功次数',
            type: 'bar',
            data: []
          }
        ]
      },
      barOptions3: {
        title: '视频通话请求与成功数',
        legend: ['请求总数', '成功次数', '扣费次数'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '次数',
          type: 'value'
        },
        series: [
          {
            name: '请求总数',
            type: 'line',
            data: []
          },
          {
            name: '成功次数',
            type: 'line',
            data: []
          },
          {
            name: '扣费次数',
            type: 'line',
            data: []
          }
        ]
      },
      barOptions4: {
        title: '通话时长',
        legend: ['通话时长'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '分钟',
          type: 'value'
        },
        series: [
          {
            name: '通话时长',
            type: 'bar',
            data: []
          }
        ]
      },
      lineOptions: {
        title: '通话',
        legend: [
          '通话成功人数',
          '通话成功次数',
          '新增用户通话成功人数',
          '新增用户通话成功次数',
          '通话请求次数',
          '通话时长'
        ],
        xAxis: {
          name: '日期',
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '数量',
          type: 'value'
        },
        series: [
          {
            name: '通话成功人数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '通话成功次数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '新增用户通话成功人数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '新增用户通话成功次数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '通话请求次数',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '通话时长',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      activeName: 'bar',
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.video,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          call_type: this.curCallType.selectValue,
          from_type: this.curFromType.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
              this.lineOptionBuild(res.data.data)
              this.barOptionsBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    //柱状图配置
    barOptionsBuild(data) {
      this.barOptions1.xAxis.data = []
      this.barOptions2.xAxis.data = []
      this.barOptions3.xAxis.data = []
      this.barOptions4.xAxis.data = []
      for (let i = 0; i < this.barOptions1.series.length; i++) {
        this.barOptions1.series[i].data = []
      }
      for (let i = 0; i < this.barOptions2.series.length; i++) {
        this.barOptions2.series[i].data = []
      }
      for (let i = 0; i < this.barOptions3.series.length; i++) {
        this.barOptions3.series[i].data = []
      }
      for (let i = 0; i < this.barOptions4.series.length; i++) {
        this.barOptions4.series[i].data = []
      }
      let item
      for (let j in data) {
        item = data[j]
        this.barOptions1.xAxis.data.push(item.date)
        this.barOptions2.xAxis.data.push(item.date)
        this.barOptions3.xAxis.data.push(item.date)
        this.barOptions4.xAxis.data.push(item.date)

        this.barOptions1.series[0].data.push(item.callingUserCount)
        this.barOptions1.series[1].data.push(item.newCallingUserCount)

        this.barOptions2.series[0].data.push(item.callingCount)
        this.barOptions2.series[1].data.push(item.newCallingCount)

        this.barOptions3.series[0].data.push(item.totalCount)
        this.barOptions3.series[1].data.push(item.callingCount)
        this.barOptions3.series[2].data.push(item.costCount)

        this.barOptions4.series[0].data.push(item.totalTime)
      }
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = []
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = []
      }
      let item
      for (let j in data) {
        item = data[j]
        this.lineOptions.xAxis.data.push(item.date)
        this.lineOptions.series[0].data.push(item.callingUserCount)
        this.lineOptions.series[1].data.push(item.callingCount)
        this.lineOptions.series[2].data.push(item.newCallingUserCount)
        this.lineOptions.series[3].data.push(item.newCallingCount)
        this.lineOptions.series[4].data.push(item.totalCount)
        this.lineOptions.series[5].data.push(item.totalTime)
      }
    },
    doInquery() {
      this.getList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.video-talk {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .bar-container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .bar {
        margin-left: 10px;
        display: inline-block;
        width: 450px;
        height: 300px;
      }
    }
  }
}
</style>
